import BaseModel from './base';
import UserDuplicateMerge from './user-duplicate-merge';
import UserDuplicateMember from './user-duplicate-member';
import { USER_DUPLICATE_MAP, USER_DUPLICATE_SOURCE_MAP, USER_DUPLICATE_STATUS_KEY, USER_DUPLICATE_MERGE_TYPE } from '@/modules/UserDuplicatesMerges/components/constants';

export default class UserDuplicate extends BaseModel {
  constructor(userDuplicate, url) {
    super(userDuplicate, url);

    this.id = userDuplicate.id;
    this.first_user_id = userDuplicate.first_user_id;
    this.second_user_id = userDuplicate.second_user_id;
    this.status = USER_DUPLICATE_MAP[userDuplicate.status];
    this.is_available_email_merge = userDuplicate.is_available_email_merge;
    this.is_available_vk_merge = userDuplicate.is_available_vk_merge;
    this.is_available_apple_merge = userDuplicate.is_available_apple_merge;
    this.is_available_telegram_merge = userDuplicate.is_available_telegram_merge;
    this.is_available_yandex_merge = userDuplicate.is_available_yandex_merge;
    this.is_available_max_merge = userDuplicate.is_available_max_merge;
    this.is_available_dispatcher_merge = userDuplicate.is_available_dispatcher_merge;

    this.user_duplicate_merges = userDuplicate?.user_duplicate_merges
      ? userDuplicate.user_duplicate_merges.map((userDuplicateMerge) => new UserDuplicateMerge(userDuplicateMerge))
      : [];
    this.other_user = userDuplicate?.other_user ? new UserDuplicateMember(userDuplicate.other_user) : null;
  }

  get availableSources() {
    return Object.values(USER_DUPLICATE_SOURCE_MAP).filter(({ backendField }) => !!this?.[backendField]);
  }

  get pendingMerge() {
    if (this.status?.id !== USER_DUPLICATE_STATUS_KEY.wait) return undefined;
    return this.user_duplicate_merges.reduce((latest, merge) => {
      if (!merge.is_confirmed) return latest;
      return !latest || merge.id > latest.id ? merge : latest;
    }, undefined);
  }

  get isPendingDispatcherMerge() {
    return this.pendingMerge?.type === USER_DUPLICATE_MERGE_TYPE.dispatcher;
  }

  canMergeWith(user) {
    return !(user?.dispatcher_id && this.other_user?.dispatcher_id);
  }
}
